import Vue from "vue";
import Vuex from "vuex";

import User from "./modules/user";
import Auth from "./modules/auth";
import Module from "./modules/module";
import Category from "./modules/category";
import Training from "./modules/training";
import WorkSheet from "./modules/worksheet";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    Auth,
    User,
    Module,
    Category,
    Training,
    WorkSheet,
  },
});
